import React, { useEffect, useContext } from "react";
import { useTranslation, Trans } from 'react-i18next';
import useForm from 'react-hook-form';
import moment from "moment";
import { ResponsiveLine  } from '@nivo/line' 

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import {transformValueFloattoFormated, formateMesAno, MaskMonthYear, transformValueFormatedtoFloat, MaskMoney, MaskDate, formateDate, convertDate,  validateDate} from "beaktShared/helpers/masks";
import Slide from "@material-ui/core/Slide";
import Success from "beaktShared/components/Typography/Success.js";
import Warning from "beaktShared/components/Typography/Warning.js";
import Danger from "beaktShared/components/Typography/Danger.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import SnackbarContent from "beaktShared/components/Snackbar/SnackbarContent.js";
import Card from "beaktShared/components/Card/Card.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import Timeline from "@material-ui/icons/Timeline";
import TimerOff from "@material-ui/icons/TimerOff";
import Select from "react-select";

// icons
import MoneyIcon from '@material-ui/icons/Money';
import MoneyOffIcon from '@material-ui/icons/MoneyOff';
import AnnouncementIcon from '@material-ui/icons/Announcement';

// services
import { SessionContext } from "beaktShared/services/session";
import { UseGetApiSimple, UsePostApi } from "beaktShared/services/crudeApiService";

// styles
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import { FormControl } from '@material-ui/core';

const useStyles = makeStyles(styles);

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

export default function Demonstrativo({clienteId, estabelecimentoId}) {
    const { t } = useTranslation();
    const session = useContext(SessionContext);
    const classes = useStyles();     

    const { register, setValue, errors, setError, clearError, getValues } = useForm({mode: "onChange"});

    const [notification, setNotification] = React.useState({
        show:false,
        color:'info',
        message:''
    });
    const showNotification = (message,color) => { 
        setNotification({
        show:true,
        color:color,
        message:message      
        });
        setTimeout(function() {
        setNotification({show:false});
        }, 6000);       
    };

    const [loadingGraficoTotalizadorDiario,setloadingGraficoTotalizadorDiario] = React.useState(false);    
    const [loading,setloading] = React.useState(false);        

    const [graficoTotalizadorDiario, setgraficoTotalizadorDiario] = React.useState(null);
    const [totalizadores, settotalizadores] = React.useState({});    
    const monthDiff = (dateFrom, dateTo) => {
        return dateTo.getMonth() - dateFrom.getMonth() + 
        (12 * (dateTo.getFullYear() - dateFrom.getFullYear()))
    }

    const [mesano, setmesano] = React.useState(formateMesAno(moment(new Date())));
    const handlePesquisar = () => {
        let data = getValues();

        if(data.mesano === "")
        {
            setError("mesano","required", t('label.required'))
            return false;
        }
        else
            clearError("mesano")

        setloading(true);

        let endpointdemonstrativo = "financeiroestabelecimento/demonstrativo/" + (session.estabelecimentoId == 0 ? 0 : session.estabelecimentoId) + "/" + data.mesano.replaceAll("/", "-");
        endpointdemonstrativo = endpointdemonstrativo + "/" + (session.estabelecimentoId == 0 ? "Franquia" : "Estabelecimento") + "/" + (session.franquiaId == 0 ? 0 : session.franquiaId);

        let endpointgrafico = "financeiroestabelecimento/grafitototalizadordiario/" + (session.estabelecimentoId == 0 ? 0 : session.estabelecimentoId)  + "/" + data.mesano.replace("/", "-");
        endpointgrafico = endpointgrafico + "/" + (session.estabelecimentoId == 0 ? "Franquia" : "Estabelecimento") + "/" + (session.franquiaId == 0 ? 0 : session.franquiaId);
        
        UseGetApiSimple(endpointdemonstrativo).then(result => {
            if (result.status !== 200) {
                showNotification(result.message, 'error')
                setloading(false);
                return false;
            }          
            setloading(false);
            settotalizadores(result.data);            
        });
        
        setloadingGraficoTotalizadorDiario(true);
        UseGetApiSimple(endpointgrafico).then(result => {
            if (result.status !== 200) {
                showNotification(result.message, 'error')
                setloadingGraficoTotalizadorDiario(false)
                return false;
            }          
            setloadingGraficoTotalizadorDiario(false);
            setgraficoTotalizadorDiario(result.data);            
            console.log(result.data);
        });
    }       
    
    useEffect(() => {
        handlePesquisar();         
    }, []);
    
    return (
        <div style={{width:'100%',padding:'20px'}}>
        {notification.show &&
            <div><br/>
            <SnackbarContent
                message={notification.message}
                color={notification.color}
                closeNotification={() => setNotification({show:false})}
                close
            />
        </div>}
        {loading && 
                <div className="carregandoCmp">
                    <div className="box">
                        <label>{t('label.loading')}...</label>
                        <CircularProgress />
                    </div>
                </div> 
                }
        <GridContainer>
            <GridItem xs={12} sm={6} md={3}>
            <FormControl fullWidth>
            <TextField
                fullWidth
                size="small"
                error={errors.mesano?true:false}
                variant="outlined"
                inputRef={register({required:t('label.required')})}
                label={t("label.month_year")}
                defaultValue={mesano}
                name="mesano"
                InputLabelProps={{shrink: true}}                
                InputProps={{ inputComponent: MaskMonthYear }}
            />
            {errors.mesano && 
                <FormHelperText>
                    <span className="obg"> {errors.mesano.message}</span>
                </FormHelperText>}
            </FormControl>
            </GridItem>
            <GridItem xs={12} sm={6} md={3}>                        
                <Button round color="primary" size="sm" onClick={e => { handlePesquisar()}}>
                {t('button.search')}
                </Button>               
            </GridItem> 
        </GridContainer>
        <br/>
        <GridContainer>                                                                        
            <GridItem xs={6} sm={6} md={4} lg={4}>
                <div className="cardT">
                    <div>
                        <Warning>
                        <h5><b>
                        {t('label.money_symbol')} {t('financial.bill_to_pay')}                         
                        </b></h5></Warning>
                    </div>
                    <div className="ico">
                        <AnnouncementIcon style={{fontSize:'35px'}} />
                    </div>
                    <div style={{clear:'both'}}></div>
                    <label>{t("financial.opened")} - {transformValueFloattoFormated(totalizadores == null ? 0 : totalizadores.totalContasPagarAberto)}</label>
                    <br/>
                    <label>{t("financial.paid_off")} - {transformValueFloattoFormated(totalizadores == null ? 0 : totalizadores.totalContasPagarLiquidado)}</label>
                </div>
            </GridItem>
            <GridItem xs={6} sm={6} md={4} lg={4}>
            <div className="cardT">
                    <div>
                        <Success>
                        <h5><b>
                        {t('label.money_symbol')} {t('financial.bill_to_receive')}                        
                        </b></h5></Success>
                    </div>
                    <div className="ico">
                        <MoneyIcon style={{fontSize:'35px'}} />
                    </div>
                    <div style={{clear:'both'}}></div>
                    <label>{t("financial.opened")} - {transformValueFloattoFormated(totalizadores == null ? 0 : totalizadores.totalContasReceberAberto)}</label>
                    <br/>
                    <label>{t("financial.paid_off")} - {transformValueFloattoFormated(totalizadores == null ? 0 : totalizadores.totalContasReceberLiquidado)}</label>
                </div>
            </GridItem>
            <GridItem xs={6} sm={6} md={4} lg={4}>
            <div className="cardT">
                    <div>
                        <Danger>
                        <h5> <b>{t('label.money_symbol')} {t('financial.expense')}
                        </b></h5></Danger>
                    </div>
                    <div className="ico">
                        <MoneyOffIcon style={{fontSize:'35px'}} />
                    </div>
                    <div style={{clear:'both'}}></div>
                    <label>{transformValueFloattoFormated(totalizadores == null ? 0 : totalizadores.totalDespesas)}</label>                    
                    <br/><br/>
                </div>
            </GridItem>                                
            <GridItem xs={12} sm={12} md={12} lg={12} style={{zIndex:'-1'}}>
                <Card>
                    <CardHeader icon>
                        <CardIcon color="primary">
                        <Timeline />
                        </CardIcon>
                        <h4 className={classes.cardIconTitle}>
                            {t("financial.daily_bond_totalizer")}                        
                        </h4>
                    </CardHeader>
                    <CardBody style={{height:'350px'}}>
                    
                        {loadingGraficoTotalizadorDiario && <div className="loadingDash"><CircularProgress size={40} /></div>}
                        {(graficoTotalizadorDiario != null && graficoTotalizadorDiario.length > 0) &&
                            <ResponsiveLine
                                data={graficoTotalizadorDiario}
                                    margin={{ top: 50, right: 110, bottom: 50, left: 60 }}
                                    xScale={{ type: 'point' }}
                                    yScale={{ type: 'linear', min: 'auto', max: 'auto', stacked: true, reverse: false }}
                                    axisTop={null}
                                    axisRight={null}
                                    colors= {['rgb(57, 115, 156)','rgba(57, 115, 156, 0.50)', 'rgb(57, 115, 156, 0.30)']}
                                    axisBottom={{
                                        orient: 'bottom',
                                        tickSize: 5,
                                        tickPadding: 5,
                                        tickRotation: 0,
                                        legend: ' ',
                                        legendOffset: 36,
                                        legendPosition: 'middle'
                                    }}
                                    axisLeft={{
                                        orient: 'left',
                                        tickSize: 5,
                                        tickPadding: 5,
                                        tickRotation: 0,
                                        legend: 'Valor',
                                        legendOffset: -40,
                                        legendPosition: 'middle'
                                    }}
                                    pointSize={10}
                                    pointColor={{ theme: 'background' }}
                                    pointBorderWidth={2}
                                    pointBorderColor={{ from: 'serieColor' }}
                                    pointLabel="y"
                                    pointLabelYOffset={-12}
                                    useMesh={true}
                                    legends={[
                                        {
                                            anchor: 'bottom-right',
                                            direction: 'column',
                                            justify: false,
                                            translateX: 100,
                                            translateY: 0,
                                            itemsSpacing: 0,
                                            itemDirection: 'left-to-right',
                                            itemWidth: 80,
                                            itemHeight: 20,
                                            itemOpacity: 0.75,
                                            symbolSize: 12,
                                            symbolShape: 'circle',
                                            symbolBorderColor: 'rgba(0, 0, 0, .5)',
                                            effects: [
                                                {
                                                    on: 'hover',
                                                    style: {
                                                        itemBackground: 'rgba(0, 0, 0, .03)',
                                                        itemOpacity: 1
                                                    }
                                                }
                                            ]
                                        }
                                    ]}
                            />
                        }
                        {(!loadingGraficoTotalizadorDiario && graficoTotalizadorDiario == null) &&
                        <div className="showNoData">
                        <TimerOff style={{fontSize:'40px'}}/>
                        <h4>
                            <Trans i18nKey="dashboard.message_no_data">
                            Oops,<br/>Não há dados nesse período.
                            </Trans>
                        </h4>
                        </div>}
                    
                    </CardBody>   
                </Card>                    
            </GridItem>
        </GridContainer>
        </div>
    );
}